import { useMutationState, useQueryClient } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { useWeek, weekSaveKey } from './api';
import { weekIsComplete } from './weekStatus';

type SaveStatusProps = { year: number; week: number };

/** What the autosave is doing, read from the mutation cache: no store, no prop drilling. */
export function SaveStatus({ year, week }: SaveStatusProps) {
  const queryClient = useQueryClient();
  const key = weekSaveKey(year, week);
  const states = useMutationState({ filters: { mutationKey: key }, select: (mutation) => mutation.state.status });
  const data = useWeek(year, week).data;
  const pending = states.includes('pending');
  const failed = states.includes('error');

  const retry = () => {
    for (const mutation of queryClient.getMutationCache().findAll({ mutationKey: key, status: 'error' })) {
      void mutation.execute(mutation.state.variables).catch(() => undefined);
    }
  };

  let text = '';
  if (pending) text = 'Opslaan…';
  else if (failed) text = 'Niet opgeslagen. Probeer opnieuw.';
  else if (data && weekIsComplete(data)) text = 'De week is rond.';
  else if (states.includes('success')) text = 'Opgeslagen';

  return (
    <p role="status" className="flex min-h-6 items-center gap-2 text-sm opacity-80">
      {text}
      {failed && !pending && (
        <Button variant="link" className="h-auto min-h-11 px-0" onClick={retry}>
          Probeer opnieuw
        </Button>
      )}
    </p>
  );
}
